import React from "react";
import {
  makeStyles,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  useTheme,
  Typography,
  Button,
  Box,
  Grid,
  Container,
  Divider,
  useMediaQuery
} from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';

export default function SubscribePage() {
  return (
    <Box>
      <Title />
      <CardLists />
    </Box>
  );
}

function Title() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)")
  return (
    <Box py={6}>
      <Container maxWidth="md">
        <Typography
          variant={isPhone ? "h6":"h5"}
          align="center"
          style={{ color: theme.palette.secondary.light }}
        >
          富屋房屋/法拍屋 - 商品價目表
          <br />
          (全省法院均一價)
        </Typography>
      </Container>
    </Box>
  );
}

function CardLists() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    cardHeader: {
      backgroundColor: theme.palette.secondary.light,
      color: "#fff",
      textAlign: "center",
      padding: "8px 0",
      "& .MuiCardHeader-title":{
        fontSize:'1.5rem',
      },
    },
  }));
  const classes = useStyles();

  const serviceList = [
    {
      title: "一個月",
      contentTitle:'如刷卡成功:',
      contentInfo:[
        "已註冊帳號者，可致電(04)2471-7673與客服核對卡號及帳號即可開通續用！",
        "未註冊帳號者，可於網頁右上免費註冊會員，註冊帳號同時完成刷卡開通作業！或者致電(04)2471-7673由客服為您核對資料開通作業！",
        "如有其他相關問題，亦可致電(04)2471-7673由客服為您解答。"
      ],
      price: "1500",
    },
    {
      title: "三個月",
      contentTitle:'如刷卡成功:',
      contentInfo:[
        "已註冊帳號者，可致電(04)2471-7673與客服核對卡號及帳號即可開通續用！",
        "未註冊帳號者，可於網頁右上免費註冊會員，註冊帳號同時完成刷卡開通作業！或者致電(04)2471-7673由客服為您核對資料開通作業！",
        "如有其他相關問題，亦可致電(04)2471-7673由客服為您解答。"
      ],
      price: "4000",
    },
    {
      title: "六個月",
      contentTitle:'如刷卡成功:',
      contentInfo:[
        "已註冊帳號者，可致電(04)2471-7673與客服核對卡號及帳號即可開通續用！",
        "未註冊帳號者，可於網頁右上免費註冊會員，註冊帳號同時完成刷卡開通作業！或者致電(04)2471-7673由客服為您核對資料開通作業！",
        "如有其他相關問題，亦可致電(04)2471-7673由客服為您解答。"
      ],
      price: "6000",
    },
    {
      title: "十二個月",
      contentTitle:'如刷卡成功:',
      contentInfo:[
        "已註冊帳號者，可致電(04)2471-7673與客服核對卡號及帳號即可開通續用！",
        "未註冊帳號者，可於網頁右上免費註冊會員，註冊帳號同時完成刷卡開通作業！或者致電(04)2471-7673由客服為您核對資料開通作業！",
        "如有其他相關問題，亦可致電(04)2471-7673由客服為您解答。"
      ],
      price: "10000",
    },
  ];

  return (
    <Box>
      <Container maxWidth="md">
        <Grid container spacing={4}>
          {serviceList.map((item) => {
            return (
              <Grid item xs={12} md={6}>
                <Card className={classes.card}>
                  <CardHeader
                    title={item.title}
                    className={classes.cardHeader}
                  />
                  <CardContent className={classes.cardContent} >
                    <Typography
                      variant="body2"
                      align="left"
                      style={{fontWeight:'400'}}
                    >
                      {item.contentTitle}
                    </Typography>
                    <ol style={{padding:'0 1em',}} >
                      {item.contentInfo.map(item=>{
                        return(
                          <li>
                            {item}
                          </li>
                        )
                      })}
                      
                    </ol>
                  </CardContent>
                  <Box style={{ padding: "0 16px 16px 16px" }}>
                    <Divider
                      style={{ backgroundColor: theme.palette.secondary.light }}
                    />
                  </Box>
                  <CardActions
                    style={{ justifyContent: "space-between", padding: "16px" }}
                  >
                    <Typography variant={isPhone ? "h5":"h4"} style={{color:theme.palette.secondary.light,fontWeight:'bold'}}>
                      ${item.price}
                    </Typography>
                    <Button
                      color="primary"
                      variant="contained"
                      style={{width:isPhone ? "120px":"150px"}}
                      size={isPhone ? "":"large"}
                    >
                      線上購買
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        {/* <Box>
          <PaginationList/>
        </Box> */}
      </Container>
    </Box>
  );
}


// pagination


function PaginationList() {
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    pagiBox: {
      marginTop:"4em",
      display:'flex',
      justifyContent:'center',
      "& .MuiPaginationItem-textSecondary.Mui-selected":{
        backgroundColor:theme.palette.secondary.light,
      },
    },
  }));
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className={classes.pagiBox}>
      <Pagination count={1} page={page} onChange={handleChange} color="secondary"  />
    </div>
  );
}
